module.exports = __webpack_public_path__ + "img/00016.b2738bd0.webp";